<template>
  <teleport to="body">
    <div class="asp-overlay" @mousedown.self="$emit('close')">
      <aside class="asp-panel" role="dialog" aria-modal="true" :aria-label="title">
        <header class="asp-head">
          <h2 class="asp-title">{{ title }}</h2>
          <button class="asp-x" type="button" aria-label="Cerrar" @click="$emit('close')"><span class="mdi mdi-close"></span></button>
        </header>
        <div class="asp-body"><slot /></div>
        <footer v-if="$slots.footer" class="asp-foot"><slot name="footer" /></footer>
      </aside>
    </div>
  </teleport>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'

const emit = defineEmits(['close'])
defineProps({ title: { type: String, required: true } })

function onKey(e) { if (e.key === 'Escape') emit('close') }
onMounted(() => window.addEventListener('keydown', onKey))
onBeforeUnmount(() => window.removeEventListener('keydown', onKey))
</script>

<style scoped>
.asp-overlay { position: fixed; inset: 0; z-index: 10000; background: rgba(15, 23, 42, 0.45); display: flex; justify-content: flex-end; }
.asp-panel {
  width: 100%; max-width: 420px; height: 100%; display: flex; flex-direction: column;
  background: #fff; box-shadow: -10px 0 40px rgba(15, 23, 42, 0.25);
  animation: asp-in 0.18s ease-out;
}
@keyframes asp-in { from { transform: translateX(30px); opacity: 0; } to { transform: none; opacity: 1; } }
.asp-head { display: flex; align-items: center; gap: 8px; padding: 18px 20px 10px; border-bottom: 1px solid #eef1f6; }
.asp-title { flex: 1; margin: 0; font: 700 16px var(--font-display); color: #1e3a5f; }
.asp-x { border: none; background: none; cursor: pointer; font-size: 20px; color: #64748b; display: flex; padding: 4px; border-radius: 6px; }
.asp-x:hover { background: #f1f5f9; }
.asp-body { flex: 1; overflow: auto; padding: 16px 20px; font: 400 13px Inter, sans-serif; color: #334155; }
.asp-foot { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 20px 16px; border-top: 1px solid #eef1f6; }
</style>